import PouchDB from 'pouchdb'
import { uiConstants } from './constants'

export const db = new PouchDB(uiConstants.pouchdb_upload_db)
